import type { SelectInputState } from '../../../../components/input/input.select';
import { MenuComponent } from '../../../../components/menu/menu';
import { type MenuItem, MenuItemComponent } from '../../../../components/menu/menu.item';
import { T, Translate } from '../../../../i18n';

export function createMenu(state: SelectInputState): MenuComponent {
	return new MenuComponent({
		items: (): MenuItem[] => {
			const items: MenuItem[] = [];
			if (state.placeholder) {
				items.push({
					view: MenuItemComponent.view([state.placeholder]),
					action: () => state.setValue(null),
				});
			}
			for (const opt of state.options) {
				items.push({
					view: MenuItemComponent.view([opt.key]),
					action: () => state.setValue(opt.value),
				});
			}
			return items;
		},
	});
}

export const selectedText = (state: SelectInputState): string => {
	const opt = state.options.find((o) => o.value === state.value);
	return opt?.key ?? Translate(T.SELECT_OPTION);
};

export const stateError = (state: SelectInputState): string | null =>
	state.touched && !state.isValid && state.hasError() ? Translate(state.error) : null;
